import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"

import { useTemplate } from "../../../../hooks/useTemplate"
import { useAnalytics } from "../../../../analytics/provider"

export const withHeroContent = Component => ({ name = "HeroContent", active, animated, handleSlide, items }) => {
  const [height, setHeight] = useState(null)
  const container = useRef()
  const { global: locales } = useTemplate()
  const { trackHeroBanner } = useAnalytics()

  const sizes = useMemo(
    () => ({
      learn: 46,
      navigator: 60,
      providers: 50,
    }),
    []
  )

  const handleClick = useCallback(
    (label, category) =>
      trackHeroBanner({
        event: "custom.banner.click",
        label,
        data: {
          value: label,
          category,
        },
      }),
    [trackHeroBanner]
  )

  useEffect(() => {
    if (active !== false && container?.current) {
      setTimeout(() => setHeight(container?.current?.clientHeight), 200)
    } else {
      setHeight(null)
    }
  }, [active, setHeight])

  Component.displayName = name
  return (
    <Component
      active={active}
      animated={animated}
      container={container}
      handleSlide={handleSlide}
      handleClick={handleClick}
      height={height}
      items={items}
      locales={locales}
      sizes={sizes}
    />
  )
}
